import TableWrapper from "../../../../src/components/TableWrapper";
import ConsoleLogSnippets from "../../../../content/posts/debugging-notes/ConsoleLogSnippets.mdx";
import * as React from 'react';
export default {
  TableWrapper,
  ConsoleLogSnippets,
  React
};